import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { DataService } from 'services/data.service';
import { Fonts } from 'domain-models/Fonts';
import { environment } from '../../environments/environment';

@Injectable()
export class FontsService extends DataService<Fonts> {
	constructor(http: Http) {
		super(environment.host + 'Fonts', http);
	}
}



// WEBPACK FOOTER //
// /Users/baselkilani/work/ODOT/projects/dmscontrol/DmsControl/src/services/fonts/fonts.service.ts